import { getProduct } from '@itau-loans-www/utils'

import consignado from './consignado'
import fgts from './fgts'

const product = getProduct()

const map = {
  fgts,
  consignado
}

const fallback = () => ({})

export default map[product] ?? fallback
